import { render, staticRenderFns } from "./CreateFormShare.vue?vue&type=template&id=dc591596&scoped=true"
import script from "./CreateFormShare.vue?vue&type=script&lang=js"
export * from "./CreateFormShare.vue?vue&type=script&lang=js"
import style0 from "./CreateFormShare.vue?vue&type=style&index=0&id=dc591596&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc591596",
  null
  
)

export default component.exports